import React from 'react';
import '../styles/Hero.css';
// Try to import the hero background, but it may not exist yet
let heroBackground;
try {
  heroBackground = require('../assets/hero-ai-bg.png');
} catch (e) {
  // Image will be handled via CSS fallback
}

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="hero" style={heroBackground ? { backgroundImage: `url(${heroBackground})` } : {}}>
      <div className="hero-zigzag hero-zigzag-left"></div>
      <div className="hero-zigzag hero-zigzag-right"></div>
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>Automate Your Business With <span className="highlight">100+ AI Agents</span></h1>
          <h2>No coding. No technical skills. Just results.</h2>
          <p>
            Connect with 200+ affiliates instantly, automate your social media, 
            and streamline your entire business with AI at the click of a button.
          </p>
          <div className="hero-buttons">
            <button onClick={scrollToContact} className="primary-button">
              Get Free Access
            </button>
            <button onClick={() => document.getElementById('features-section').scrollIntoView({ behavior: 'smooth' })} 
              className="secondary-button">
              Explore AI Agents
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
